import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";
import { object } from "yup";
import { useTranslation } from "react-i18next";

export default function AuthForm({ children, fields, onSubmit, onSubmitLabel, apiErrors, yup }) {
  const {t} = useTranslation('translation', {keyPrefix: 'form'});
  const initialValues = fields.reduce((obj, cur) => ({...obj, [cur.id]: ''}), {});
  const validationSchema = object().shape(yup);

  const getFields = (errors, handleChange, values) => {
    return (
      fields.map(field => (
        <Form.Group className="mb-4" controlId={field.id}>
          <Form.Label className="text-black">{t(field.id)}</Form.Label>
          <Form.Control className="border-black text-black"
                        isInvalid={!!errors[field.id]}
                        onChange={handleChange}
                        required autoComplete={field.autoComplete}
                        size='lg' type={field.type}
                        value={values[field.id]} />
            {children}
          <Form.Control.Feedback type="invalid">{errors[field.id]}</Form.Control.Feedback>
        </Form.Group>
      ))
    );
  }

  return (
    <Formik initialValues={initialValues}
    enableReinitialize
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={(values, { setSubmitting }) => {
              onSubmit(values).then(setSubmitting(false));
            }}>
      {({ errors, handleChange, handleSubmit, isSubmitting, values }) => (
        <Form noValidate onSubmit={handleSubmit} style={{padding: '2em'}}>
          {apiErrors && <p className="text-danger">{apiErrors}</p>}
          {getFields(errors, handleChange, values)}
          <Button className='text-capitalize' variant="primary" type="submit" disabled={isSubmitting}>
            {onSubmitLabel}
          </Button>
        </Form>
      )}
    </Formik>
  );
}
